<template>
    <v-container fluid>
        <v-card class="pa-4">
            <v-card-title class="text-h5 mb-4">
                Добавить контрагента
            </v-card-title>

            <v-card-text>
                <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
                    <v-text-field v-model="cargoType.name" label="Добавить контрагента" :rules="nameRules" required
                        maxlength="30" counter outlined class="mb-4"></v-text-field>

                    <v-alert v-if="successMessage" type="success" dense class="mb-4">
                        {{ successMessage }}
                    </v-alert>

                    <v-alert v-if="errorMessage" type="error" dense class="mb-4">
                        {{ errorMessage }}
                    </v-alert>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="resetForm" color="secondary" class="mr-2">
                            Очистить
                        </v-btn>
                        <v-btn type="submit" color="primary" :disabled="!valid" :loading="loading">
                            Добавить контрагента
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import router from '../../router';

export default {
    name: 'AddCargoType',

    data() {
        return {
            valid: false,
            loading: false,
            successMessage: '',
            errorMessage: '',
            cargoType: {
                name: ''
            },
            nameRules: [
                v => !!v || 'Имя обязательно',
                v => (v && v.length <= 30) || 'Имя должно содержать максимум 30 символов'
            ]
        }
    },

    methods: {
        async submitForm() {
            if (!this.$refs.form.validate()) {
                return
            }

            this.loading = true
            this.successMessage = ''
            this.errorMessage = ''

            try {
                // Replace with your actual API call
                const response = await this.axios.post('/cargotypes', this.cargoType)

                if (response.status === 200 || response.status === 201) {
                    this.successMessage = 'Контрагент добавлен успешно!'
                    this.resetForm()
                    router.push('/settings/cargoTypes/')
                }
            } catch (error) {
                this.errorMessage = error.response?.data?.message || 'Ошибка добавления контрагента'
                console.error('Ошибка добавления контрагента:', error)
            } finally {
                this.loading = false
            }
        },

        resetForm() {
            this.$refs.form.reset()
            this.successMessage = ''
            this.errorMessage = ''
        }
    }
}
</script>